export enum CommentsTable {
  Task = "Task"
}
